import porfolio01 from './images/portf-1.png';
import porfolio02 from './images/portf-2.png';
import porfolio03 from './images/portf-3.png';
import porfolio04 from './images/portf-4.png';
import porfolio05 from './images/portf-5.png';
import porfolio06 from './images/portf-6.png';

const projectsList = [
    {
        id: 1,
        title: {
            en: 'Website für gepanzerte Fenste',
            ua: 'Website für gepanzerte Fenste',
            ru: 'Website für gepanzerte Fenste',
            de: 'Website für gepanzerte Fenster',
        },
        description: {
            en: 'Shopify',
            ua: 'Shopify',
            ru: 'Shopify',
            de: 'Shopify',
        },
        image: porfolio01,
        tags: {
            en: ['Development', 'Shopify', 'USA'],
            ua: ['Development', 'Shopify', 'USA'],
            ru: ['Разработка', 'Shopify', 'США'],
            de: ['Entwicklung', 'Word Press', 'USA'],
        },
        link: 'https://skygenwindows.com/',
    },
    {
        id: 2,
        title: {
            en: 'Baumarkt in London',
            ua: 'Baumarkt in London',
            ru: 'Baumarkt in London',
            de: 'Baumarkt in London',
        },
        description: {
            en: 'Shopify',
            ua: 'Shopify',
            ru: 'Shopify',
            de: 'Shopify',
        },
        image: porfolio02,
        tags: {
            en: ['UX/UI', 'Development', 'Word Press', 'Canada'],
            ua: ['UX/UI', 'Development', 'Word Press', 'Canada'],
            ru: ['UX/UI', 'Разработка', 'Word Press', 'Канада'],
            de: ['UX/UI', 'Entwicklung', 'Shopify'],
        },
        link: 'https://capitalbms.co.uk/',
    },
    {
        id: 3,
        title: {
            en: 'Website für den Verkauf von Proteinprodukten',
            ua: 'Website für den Verkauf von Proteinprodukten',
            ru: 'Website für den Verkauf von Proteinprodukten',
            de: 'Website für den Verkauf von Proteinprodukten',
        },
        description: {
            en: 'Shopify',
            ua: 'Shopify',
            ru: 'Shopify',
            de: 'Shopify',
        },
        image: porfolio03,
        tags: {
            en: ['UX/UI', 'Development', 'Word Press', 'Ukraine'],
            ua: ['UX/UI', 'Development', 'Word Press', 'Ukraine'],
            ru: ['UX/UI', 'Разработка', 'Word Press', 'Украина'],
            de: ['UX/UI', 'Entwicklung', 'Shopify'],
        },
        link: 'https://dod.live/',
    },
    {
        id: 4,
        title: {
            en: 'Baumarkt in London',
            ua: 'Baumarkt in London',
            ru: 'Baumarkt in London',
            de: 'Baumarkt in London',
        },
        description: {
            en: 'Shopify',
            ua: 'Shopify',
            ru: 'Shopify',
            de: 'Shopify',
        },
        image: porfolio04,
        tags: {
            en: ['UX/UI', 'Development', 'Next.js', 'Canada'],
            ua: ['UX/UI', 'Development', 'Next.js', 'Canada'],
            ru: ['UX/UI', 'Разработка', 'Next.js', 'Канада'],
            de: ['UX/UI', 'Entwicklung', 'Shopify'],
        },
        link: 'https://luxhairnyc.shop/',
    },
    {
        id: 5,
        title: {
            en: 'Website für den Verkauf von Körperölen',
            ua: 'Website für den Verkauf von Körperölen',
            ru: 'Website für den Verkauf von Körperölen',
            de: 'Website für den Verkauf von Körperölen',
        },
        description: {
            en: 'Shopify',
            ua: 'Shopify',
            ru: 'Shopify',
            de: 'Shopify',
        },
        image: porfolio05,
        tags: {
            en: ['UX/UI', 'Development', 'Shopify', 'Ukraine'],
            ua: ['UX/UI', 'Development', 'Shopify', 'Ukraine'],
            ru: ['UX/UI', 'Разработка', 'Shopify', 'Украина'],
            de: ['UX/UI', 'Entwicklung', 'Shopify'],
        },
        link: 'https://finescents.co.uk/',
    },
    {
        id: 6,
        title: {
            en: 'Website für den Verkauf von Zeichnungen',
            ua: 'Website für den Verkauf von Zeichnungen',
            ru: 'Website für den Verkauf von Zeichnungen',
            de: 'Website für den Verkauf von Zeichnungen',
        },
        description: {
            en: 'Shopify',
            ua: 'Shopify',
            ru: 'Shopify',
            de: 'Shopify',
        },
        image: porfolio06,
        tags: {
            en: ['UX/UI', 'Development', 'Shopify', 'Ukraine'],
            ua: ['UX/UI', 'Development', 'Shopify', 'Ukraine'],
            ru: ['UX/UI', 'Разработка', 'Shopify', 'Украина'],
            de: ['UX/UI', 'Entwicklung', 'Shopify'],
        },
        link: 'https://craftoriashop.pl/',
    },
];

export { projectsList };
